export default __webpack_public_path__ + "static/media/6.e41b32a9.jpeg";